import { Link } from "react-router-dom";
import { Users, UserCheck, BookOpen, Link2, ClipboardList, Award, ArrowRight } from "lucide-react";
import { useApi } from "../../lib/api";
import { Stagger, AnimatedCard } from "../../components/motion";
import { PageHeader, SkeletonGrid, ErrorState } from "../../components/common";
import { StatCard } from "../student/Dashboard";

const STATS = [
  ["students", "Toplam Kursiyer", Users, "text-[var(--brand)] bg-[var(--brand-50)]"],
  ["active_students", "Aktif Kursiyer", UserCheck, "text-emerald-600 bg-emerald-50"],
  ["courses", "Eğitim Sayısı", BookOpen, "text-indigo-600 bg-indigo-50"],
  ["assignments", "Atanmış Eğitim", Link2, "text-sky-600 bg-sky-50"],
  ["exams", "Sınav Sayısı", ClipboardList, "text-amber-600 bg-amber-50"],
  ["certificates", "Sertifika Sayısı", Award, "text-fuchsia-600 bg-fuchsia-50"],
];

const LINKS = [
  ["/admin/kursiyerler", "Kursiyer Ekle", "Yeni kursiyer hesabı oluşturun."],
  ["/admin/atamalar", "Eğitim Ata", "Kursiyerlere eğitim programı atayın."],
  ["/admin/egitimler", "Eğitim Oluştur", "Modül ve dersleriyle yeni eğitim."],
];

export default function AdminDashboard() {
  const { data, loading, error, reload } = useApi("/admin/stats");
  return (
    <div>
      <PageHeader eyebrow="Yönetim Paneli" title="Genel Bakış" desc="SK Enstitü eğitim platformunun anlık durumu." />
      {error ? (
        <ErrorState message={error} onRetry={reload} />
      ) : loading ? (
        <SkeletonGrid count={6} className="h-36" cols="grid-cols-2 lg:grid-cols-3" />
      ) : (
        <Stagger className="grid grid-cols-2 gap-4 sm:gap-5 lg:grid-cols-3" gap={0.07}>
          {STATS.map(([k, label, icon, tone]) => (
            <StatCard key={k} label={label} icon={icon} tone={tone} value={data[k]} testid={`admin-stat-${k}`} />
          ))}
        </Stagger>
      )}
      <h2 className="mb-4 mt-10 text-lg font-bold">Hızlı İşlemler</h2>
      <Stagger className="grid gap-4 md:grid-cols-3" gap={0.08} delay={0.3}>
        {LINKS.map(([to, t, d]) => (
          <AnimatedCard key={to} className="group">
            <Link to={to} className="flex items-center gap-4 p-5" data-testid={`admin-quick-${to.split("/").pop()}`}>
              <div className="flex-1"><p className="font-bold text-[var(--ink)]">{t}</p><p className="text-sm text-slate-500">{d}</p></div>
              <ArrowRight className="h-5 w-5 text-slate-300 transition-transform duration-300 group-hover:translate-x-1 group-hover:text-[var(--brand)]" />
            </Link>
          </AnimatedCard>
        ))}
      </Stagger>
    </div>
  );
}
